var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17486_28950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28C21.732 28 28 21.732 28 14Z",
    fill: "#E8F1FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_17486_28950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.35135 11.8093C7.35135 12.5343 7.60967 12.676 8.03466 12.826L8.8763 13.1176V10.7344H8.33465C7.793 10.7344 7.35135 11.2177 7.35135 11.8093Z",
    fill: "url(#paint0_linear_17486_28950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2783 22.6655C14.4867 22.6655 17.0876 20.0646 17.0876 16.8562C17.0876 13.6478 14.4867 11.0468 11.2783 11.0468C8.06988 11.0468 5.46895 13.6478 5.46895 16.8562C5.46895 20.0646 8.06988 22.6655 11.2783 22.6655Z",
    fill: "url(#paint1_linear_17486_28950)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_17486_28950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9636 16.248H12.151C12.0262 16.248 11.9167 16.2952 11.823 16.3888C11.7291 16.4826 11.6823 16.5919 11.6823 16.7169V19.5296C11.6823 19.6546 11.7293 19.7641 11.823 19.8577C11.9167 19.9513 12.026 19.9984 12.151 19.9984H14.9636C15.0884 19.9984 15.1982 19.9514 15.2915 19.8577C15.3855 19.7641 15.4325 19.6546 15.4325 19.5296V16.7169C15.4325 16.5919 15.3857 16.4826 15.2915 16.3888C15.1982 16.295 15.0884 16.248 14.9636 16.248Z",
    fill: "url(#paint2_linear_17486_28950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6554 7.82822C18.335 7.23806 17.921 6.74025 17.4131 6.3339C16.9054 5.9277 16.3347 5.60331 15.702 5.36122C15.0692 5.11922 14.4404 4.99805 13.8152 4.99805C11.4403 4.99805 9.6279 6.03713 8.37777 8.11534C8.31534 8.21685 8.29379 8.3262 8.31328 8.44342C8.3329 8.56049 8.39345 8.65818 8.49499 8.73629L10.4169 10.2013C10.5185 10.2637 10.6162 10.2949 10.71 10.2949C10.8506 10.2949 10.9716 10.2323 11.0733 10.1073C11.6357 9.40427 12.0538 8.95506 12.3272 8.75964C12.6632 8.53315 13.0849 8.41994 13.5928 8.41994C14.0693 8.41994 14.4891 8.54497 14.8526 8.79478C15.2158 9.04483 15.3973 9.33392 15.3973 9.66204C15.3973 10.0291 15.2998 10.3261 15.1044 10.5527C14.9092 10.7792 14.5809 10.9978 14.1199 11.2088C13.5107 11.4822 12.9518 11.9061 12.4443 12.4804C11.9363 13.0546 11.6825 13.666 11.6825 14.3144V14.8417C11.6825 14.9903 11.7233 15.1367 11.8055 15.2812C11.8876 15.4259 11.9871 15.4981 12.1044 15.4981H14.9169C15.0419 15.4981 15.1512 15.4377 15.245 15.3162C15.3386 15.1954 15.3857 15.0684 15.3857 14.9358C15.3857 14.7405 15.4931 14.4785 15.7078 14.1506C15.9226 13.8224 16.1901 13.5683 16.5107 13.3885C16.8152 13.2167 17.0533 13.0782 17.2254 12.9726C17.3976 12.8673 17.622 12.697 17.8995 12.4628C18.1768 12.2283 18.3916 11.9959 18.5438 11.7655C18.6962 11.5351 18.833 11.2362 18.9541 10.8689C19.0754 10.5017 19.1358 10.1071 19.1358 9.68532C19.1358 9.03687 18.9755 8.41777 18.6554 7.82822Z",
    fill: "url(#paint3_linear_17486_28950)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_17486_28950",
    x: 0.325228,
    y: 5.59065,
    width: 21.9061,
    height: 22.2191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.714406,
    dy: 0.714406
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.357203
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_17486_28950"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_17486_28950",
    x: 3.76516,
    y: 0.456867,
    width: 19.9118,
    height: 24.0824,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.630719,
    dy: 0.630719
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.315359
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_17486_28950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17486_28950",
    x1: 11.2783,
    y1: 10.7344,
    x2: 1.32614,
    y2: 21.6454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17486_28950",
    x1: 11.2783,
    y1: 11.0469,
    x2: 1.61424,
    y2: 21.9278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17486_28950",
    x1: 14.0553,
    y1: 4.9981,
    x2: 18.8703,
    y2: 21.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0063F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17486_28950",
    x1: 14.0553,
    y1: 4.99805,
    x2: 18.8703,
    y2: 21.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0063F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17486_28950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.f84957f550f214cfbd5ce478781b87ae.svg";
export { ForwardRef as ReactComponent };